module.exports = __webpack_public_path__ + "static/img/3-title.0492f4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/3-title.png
// module id = efZz
// module chunks = 0